import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'carryover-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './carryover-tag.component.html',
  styleUrls: ['./carryover-tag.component.css', '../../common/scss/route-itinerary-common.scss'],
})
export class CarryoverTagComponent implements OnInit {
  @Input() count: number = 1;
  constructor() {}

  ngOnInit(): void {}
}
